const thMessages = {
  /* 01.General */
  "chat.end": "เริ่มการสนทนาของคุณใหม่",
  "chat.endall": "สิ้นสุดการแชท",
  "chat.cancel": "ยกเลิก",
  "chat.cookie":
    "ผู้ช่วยดิจิทัลนี้ใช้คุกกี้เพื่อให้แน่ใจว่าคุณได้รับประสบการณ์ที่ดีที่สุด",
  "chat.learn": "เรียนรู้เพิ่มเติม",
  "chat.minimize": "ย่อเล็กสุด",
  "chat.hide": "ปิด I",
  "chat.hidebot.text": "ปิดจะทำให้อวาตาร์หายไปเป็นเวลา 15 นาที",
  "chat.hidebot": "ปิดบอท",
  "chat.restart": "เริ่มต้นใหม่",
  "switch.language": "เปลี่ยนภาษา",
  "switch.property": "เปลี่ยนคุณสมบัติ",
  "restart.converstation": "เริ่มการสนทนาใหม่",
  "chat.endtext": "คุณแน่ใจหรือไม่ว่าต้องการสิ้นสุดการแชทปัจจุบัน",
  "check.availabity": "ตรวจสอบห้องว่าง",
  "check.availabity.submit": "ส่ง",
  "check.availabity.cancel": "ยกเลิก",
  "check.availabity.adults": "ผู้ใหญ่ ",
  "check.availabity.children": "เด็ก",
  "check.availabity.child.age": "อายุ - เด็ก",
  "feedback.leave": "แสดงความคิดเห็น",
  "feedback.leave.message": "ทิ้งข้อความไว้",
  "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email": " Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "ส่งเคส",
  "caseform.system": "ระบบ",
  "caseform.loading.systems": "กำลังโหลดระบบ...",
  "caseform.select.system": "เลือกระบบ",
  "caseform.error.systems": "เกิดข้อผิดพลาดในการโหลดระบบ",
  "caseform.scenario": "สถานการณ์",
  "caseform.loading.scenarios": "กำลังโหลดสถานการณ์...",
  "caseform.select.scenario": "เลือกสถานการณ์",
  "caseform.error.scenarios": "เกิดข้อผิดพลาดในการโหลดสถานการณ์",
  "caseform.topic": "หัวข้อ",
  "caseform.loading.topics": "กำลังโหลดหัวข้อ...",
  "caseform.select.topic": "เลือกหัวข้อ",
  "caseform.error.topics": "เกิดข้อผิดพลาดในการโหลดหัวข้อ",
  "caseform.productArea": "Product Areas",
  "caseform.loading.productAreas": "Loading product areas...",
  "caseform.select.productArea": "Select Product Area",
  "caseform.error.productAreas": "Error loading product areas",
  "caseform.module": "Modules",
  "caseform.loading.modules": "Loading modules...",
  "caseform.select.module": "Select Module",
  "caseform.error.modules": "Error loading modules",
  "caseform.feature": "Features",
  "caseform.loading.features": "Loading features...",
  "caseform.select.feature": "Select Feature",
  "caseform.error.features": "Error loading features",
  "caseform.subject": "หัวข้อเรื่อง",
  "caseform.description": "รายละเอียด",
  "caseform.attachments": "ไฟล์แนบ",
  "caseform.attachments.remove": "ลบ",
  "caseform.submit": "ส่ง",
  "caseform.cancel": "ยกเลิก",
  "caseform.success.title": "สร้างเคสแล้ว",
  "caseform.success.message": "เคสของคุณถูกสร้างเรียบร้อยแล้ว",
  "caseform.success.caseNumber": "หมายเลขเคส:",
  "caseform.success.transferToLiveAgent":
    "คุณกำลังถูกโอนไปยังเจ้าหน้าที่ให้บริการสด",
  "caseform.success.newChatWindowRightSide":
    "หน้าต่างแชทใหม่จะเปิดทางด้านขวาของเบราว์เซอร์ของคุณ",
  "caseform.success.ok": "ตกลง",
  "simpleaction.title": "เลือกการกระทำ",
  "simpleaction.body":
    "โปรดเลือกหนึ่งในตัวเลือกต่อไปนี้:{br}{b}สร้างเคส{/b} เพื่อส่งคำขอสนับสนุน หรือ {b}เริ่มแชท{/b} เพื่อเชื่อมต่อกับตัวแทนตอนนี้",
  "simpleaction.startchat": "เริ่มแชท",
  "simpleaction.createcase": "สร้างเคส",
  "caseform.error.generic": "เกิดข้อผิดพลาดในการสร้างเคส",
  "caseform.error.generic.message":
    "เกิดข้อผิดพลาดในการสร้างเคสของคุณ โปรดลองอีกครั้งในภายหลัง",
};
export default thMessages;
